// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8b600499","607":"77de4698","663":"77de4698","733":"77de4698","973":"77de4698"}[chunkId] + ".chunk.css";
};